import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { Picture } from "../../components/wpl/image/src/image";

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingInline: "80px", // Logical property
    backgroundColor: wacToken("color.neutral.light0"),
    boxShadow: token("elevation.shadow.overlay"),
    position: "relative",
    zIndex: "9",
    minHeight: "72px",
    maxHeight: "120px",
    width: "100%",
    overflow: "visible",

    [media.below.sm]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingBlock: "20px"
    }
});

const logoStyle = css({
    blockSize: "30px",
    marginBlockEnd: "20px",

    [media.above.sm]: {
        marginBlockEnd: "0"
    }
});

const linkStyle = css({
    textDecoration: "none",
    color: wacToken("color.primary.blue"),
    margin: "0 10px"
});

const buttonStyle = css({
    padding: "5px 15px",
    backgroundColor: wacToken("color.primary.blue"),
    color: "white",
    border: "none",
    borderRadius: "3px",
    cursor: "pointer",
    textDecoration: "none",
    margin: "0",
    alignSelf: "flex-start",

    [media.below.sm]: {
        marginBlockStart: "80px"
    }
});

export const SourcetreeAppNav = () => {
    return (
        <header css={headerStyle}>
            <div>
                <a href="/" css={linkStyle}>
                    <Picture
                        image={{
                            src: "https://wac-cdn.atlassian.com/dam/jcr:f32681c1-355d-4806-b29c-319b0c6ecb06/Sourcetree-blue.svg?cdnVersion=3108",
                            alt: "Sourcetree logo"
                        }}
                        style={{
                            height: "30px"
                        }}
                        css={logoStyle}
                    />
                </a>
            </div>
            <div>
                <a
                    href="https://product-downloads.atlassian.com/software/sourcetree/ga/Sourcetree_4.2.14_297.zip"
                    css={buttonStyle}
                >
                    Download free
                </a>
            </div>
        </header>
    );
};
